import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { WHAT_IF_URL, WHAT_IF_RESULTS_URL } from 'src/constants/constants.js';
import { updateBodyClass } from 'src/helpers';
import Layout from 'src/ui/layout';
import { WhatIfCalculatorContainer, WhatIfResultsContainer } from './containers';
import { history } from 'src/store/configureStore';

class WhatIfRoot extends React.Component {
  componentDidMount() {
    updateBodyClass('whatif');
  }
  componentWillUnmount() {
    updateBodyClass('whatif');
  }
  render() {
    return (
      <Layout headerName={'What if calculator'}>
        <Switch>
          <Route path={WHAT_IF_RESULTS_URL + '/:resultIndex'} render={props => <WhatIfResultsContainer {...props} history={history} />} />
          <Route path={WHAT_IF_RESULTS_URL} render={props => <WhatIfResultsContainer {...props} history={history} />} />
          <Route path={WHAT_IF_URL} render={props => <WhatIfCalculatorContainer {...props} history={history} />} />
        </Switch>
      </Layout>
    );
  }
}

export default WhatIfRoot;
